// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Piw","col":"styles_col__2keRq","actions":"styles_actions__1co_r","conflict":"styles_conflict__272qN"};